import React from 'react';
import ProductList from './ProductList';
import PackageGroup from './PackageGroup';
import { orderItemsContainerDefaultProps, orderItemsContainerProps } from './props';

/**
 * OrderItemsContainer Component
 *
 * Wrapper component that handles displaying order items on the order details page,
 * either grouped by packages or as a flat list of products.
 */
export default function OrderItemsContainer({
  orderProducts,
  packages,
  text,
  currency,
  currencySymbol,
}) {
  // If no products, render nothing
  if (!orderProducts?.length) {
    return null;
  }

  // If we have more than one package, group by packages and show unshipped items separately
  if (Array.isArray(packages) && packages.length > 1) {
    // Get all orderLineKeys that belong to packages
    const packageOrderLineKeys = packages.reduce((keys, packageData) => {
      if (packageData?.orderLineKeys && Array.isArray(packageData.orderLineKeys)) {
        return [...keys, ...packageData.orderLineKeys];
      }
      return keys;
    }, []);

    // Filter out products that don't belong to any package (unshipped items)
    const unshippedProducts = orderProducts.filter(
      (product) => !packageOrderLineKeys.includes(product?.orderLineKey),
    );

    return (
      <>
        {/* Render all packages */}
        {packages.map((packageData) => {
          if (typeof packageData !== 'object' || !packageData || !packageData.packageNumber) {
            return null;
          }
          return (
            <PackageGroup
              key={packageData?.packageNumber}
              packageData={packageData}
              allOrderProducts={orderProducts}
              text={packageData?.packageTexts || text}
              currency={currency}
              currencySymbol={currencySymbol}
            />
          );
        })}

        {/* Render unshipped items if any exist */}
        {unshippedProducts?.length > 0 && (
          <ProductList
            orderProducts={unshippedProducts}
            text={text}
            currency={currency}
            currencySymbol={currencySymbol}
          />
        )}
      </>
    );
  }

  // Otherwise render products as a flat list
  return (
    <ProductList
      orderProducts={orderProducts}
      text={text}
      currency={currency}
      currencySymbol={currencySymbol}
    />
  );
}

OrderItemsContainer.propTypes = orderItemsContainerProps;
OrderItemsContainer.defaultProps = orderItemsContainerDefaultProps;
